import { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera'
import { Animatable, Animation, BezierCurveEase } from '@babylonjs/core/Animations'
import { Scene } from '@babylonjs/core/scene'
import { Mesh } from '@babylonjs/core/Meshes'

export function createDefaultCameraResetAnimation (camera:ArcRotateCamera) {
  const { target, radius, alpha, beta } = camera
  const params: Partial<ArcRotateCamera> = { target: target.clone(), radius, alpha, beta }

  const bezierEase = new BezierCurveEase(0.03, 0.39, 0.32, 0.91)
  const cameraProps: (keyof ArcRotateCamera)[] = ['target', 'radius', 'alpha', 'beta']

  const animations = cameraProps.map(name => {
    const animation = new Animation(
      name,
      name,
      100,
      Animation.ANIMATIONTYPE_FLOAT,
      Animation.ANIMATIONLOOPMODE_CONSTANT
    )
    animation.setKeys([
      { frame: 0, value: params[name] },
      { frame: 100, value: params[name] }
    ])
    animation.setEasingFunction(bezierEase)
    if (name === 'target') {
      animation.dataType = Animation.ANIMATIONTYPE_VECTOR3
    }
    return animation
  })
  camera.animations = animations
}

export function resetCameraView (camera:ArcRotateCamera) {
  const cameraProps: (keyof ArcRotateCamera)[] = ['target', 'radius', 'alpha', 'beta']
  cameraProps.forEach((name) => {
    const animation = camera.getAnimationByName(name)
    if (!animation) { return }

    animation.setKeys([
      { frame: 0, value: camera[name] },
      animation.getKeys()[1]
    ])
  })
  camera.getScene().beginAnimation(camera, 0, 100)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function restorePreviousState (scene: Scene, prevState: any) {
  const camera = scene.activeCamera as ArcRotateCamera
  const bezierEase = new BezierCurveEase(0.03, 0.39, 0.32, 0.91)
  const cameraProps: (keyof ArcRotateCamera)[] = ['target', 'radius', 'alpha', 'beta']

  const animations: Animation[] = cameraProps.map(name => {
    const animation = new Animation(
      name,
      name,
      100,
      Animation.ANIMATIONTYPE_FLOAT,
      Animation.ANIMATIONLOOPMODE_CONSTANT
    )
    animation.setKeys([
      { frame: 0, value: camera[name] },
      { frame: 100, value: prevState[name] }
    ])
    animation.setEasingFunction(bezierEase)
    if (name === 'target') {
      animation.dataType = Animation.ANIMATIONTYPE_VECTOR3
    }
    return animation
  })
  await scene.beginDirectAnimation(camera, animations, 0, 100, false).waitAsync()
}

export function start3DRotateAnimation (scene: Scene, target: Mesh, frameRate = 10.0): Animatable {
  const yRotation = new Animation(
    'yRotation',
    'rotation.y',
    frameRate,
    Animation.ANIMATIONTYPE_FLOAT,
    Animation.ANIMATIONLOOPMODE_CYCLE
  )

  yRotation.setKeys([
    { frame: 0, value: 0 },
    { frame: 300, value: -2 * Math.PI }
  ])

  return scene.beginDirectAnimation(target, [yRotation], 0, 300, true)
}
